import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserHistory } from "history";
import React from "react";
import { CookiesProvider } from "react-cookie";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux"; //-- This wil provide Redux store data to our React components.
import { Route, Router } from "react-router-dom";
import { Auth0Provider } from "./auth/auth0";
import App from "./components/App";
import configureStore from "./redux/store/configureStore";

import "react-widgets/styles.css"; //-- This is the css that is used for the DateTimePicker

export const reduxStore = configureStore();
const browserHistory = createBrowserHistory({
	basename: process.env.PUBLIC_PATH,
});

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
});

const container = document.getElementById("app");
const root = createRoot(container);
root.render(
	<Auth0Provider
		domain={process.env.aerialPlotConnections.aerialPlotWeb.domain}
		client_id={process.env.aerialPlotConnections.aerialPlotWeb.clientId}
		redirect_uri={process.env.aerialPlotConnections.aerialPlotWeb.redirectUri}
		audience={process.env.aerialPlotConnections.aerialPlotWeb.apiAudience}
	>
		<ReduxProvider store={reduxStore}>
			<QueryClientProvider client={queryClient}>
				<Router history={browserHistory}>
					<Route>
						<CookiesProvider>
							<App browserHistory={browserHistory} />
						</CookiesProvider>
					</Route>
				</Router>
			</QueryClientProvider>
		</ReduxProvider>
	</Auth0Provider>,
);
